import * as Sentry from '@sentry/react';
import { FC, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Styled from './ErrorScreen.styled';

interface ErrorScreenProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  ctaLabel?: ReactNode;
  errorName: string;
}

export const ErrorScreen: FC<ErrorScreenProps> = ({
  title,
  subtitle,
  ctaLabel,
  errorName,
}) => {
  useEffect(() => {
    Sentry.captureEvent({ message: errorName });
  }, []);

  const navigate = useNavigate();

  return (
    <Styled.Container>
      <Styled.Card>
        <Styled.ErrorImage />
        {title && <Styled.Title>{title}</Styled.Title>}
        {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
        {ctaLabel && (
          <Styled.Button onClick={() => navigate('/')}>
            {ctaLabel}
          </Styled.Button>
        )}
      </Styled.Card>
    </Styled.Container>
  );
};
